var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    { ref: "form", attrs: { model: _vm.value.config, disabled: _vm.disabled } },
    [
      _c(
        "div",
        { staticClass: "magic_nav_auto_config" },
        _vm._l(_vm.value.config.value, function (item, index) {
          return _c("div", { key: index, staticClass: "upload-item" }, [
            _c(
              "div",
              { staticClass: "upload" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "value." + index + ".link_value",
                      rules: [{ required: true, message: "菜单不可为空" }],
                    },
                  },
                  [
                    _c("el-cascader", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        options: _vm.menuListFilter,
                        "collapse-tags": "",
                        props: {
                          label: "show_name",
                          value: "id",
                          children: "childrens",
                          checkStrictly: true,
                          emitPath: false,
                        },
                        filterable: "",
                        placeholder: "选择菜单",
                      },
                      model: {
                        value: item.link_value,
                        callback: function ($$v) {
                          _vm.$set(item, "link_value", $$v)
                        },
                        expression: "item.link_value",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "upload-item-wrap" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: "value." + index + ".small_imageurl",
                          rules: [{ required: true, message: "图片不可为空" }],
                        },
                      },
                      [
                        _c("upload-file", {
                          ref: "uploadBannerSmall",
                          refInFor: true,
                          attrs: {
                            "link-url": _vm.linkUrl,
                            tempurl: item.small_imageurl,
                            canDel: Boolean(item.small_imageurl),
                            deletePadding: true,
                            uploadInfo: _vm.uploadInfo,
                          },
                          on: {
                            onDelete: function ($event) {
                              return _vm.onDelete(item, "small_imageurl")
                            },
                            emitUploadFile: function (res) {
                              return _vm.emitUploadFile(
                                res,
                                item,
                                "small_imageurl"
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "btns" },
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.onUpload(index, "Small")
                              },
                            },
                          },
                          [_vm._v(" 上传图片 ")]
                        ),
                        _vm.pictureInfo[index * 2 + 1]
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.selectPicture(
                                      index,
                                      index * 2 + 1,
                                      "small_imageurl"
                                    )
                                  },
                                },
                              },
                              [_vm._v(" 选择图片 ")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "tips",
                    staticStyle: { "margin-bottom": "15px" },
                  },
                  [
                    _vm._v(
                      " 建议尺寸为335*204，支持JPG、PNG等格式，大小不超过2M "
                    ),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "upload-item-wrap" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: "value." + index + ".big_imageurl",
                          rules: [{ required: true, message: "图片不可为空" }],
                        },
                      },
                      [
                        _c("upload-file", {
                          ref: "uploadBannerBig",
                          refInFor: true,
                          attrs: {
                            "link-url": _vm.linkUrl,
                            tempurl: item.big_imageurl,
                            canDel: Boolean(item.big_imageurl),
                            deletePadding: true,
                            uploadInfo: _vm.uploadInfo,
                          },
                          on: {
                            onDelete: function ($event) {
                              return _vm.onDelete(item, "big_imageurl")
                            },
                            emitUploadFile: function (res) {
                              return _vm.emitUploadFile(
                                res,
                                item,
                                "big_imageurl"
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "btns" },
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.onUpload(index, "Big")
                              },
                            },
                          },
                          [_vm._v(" 上传图片 ")]
                        ),
                        _vm.pictureInfo[index * 2 + 2]
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.selectPicture(
                                      index,
                                      index * 2 + 2,
                                      "big_imageurl"
                                    )
                                  },
                                },
                              },
                              [_vm._v(" 选择图片 ")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "tips" }, [
                  _vm._v(
                    " 卡规则不支持另一个菜单时自动平铺开的图片，建议尺寸为690*165，格式和大小要求跟上述一致 "
                  ),
                ]),
              ],
              1
            ),
          ])
        }),
        0
      ),
      _c(
        "el-form-item",
        {
          staticClass: "margin_top",
          attrs: {
            prop: "margin_top",
            rules: [{ type: "number", message: "间距必须为数字值" }],
          },
        },
        [
          _c("div", [_vm._v(" 与上方组件的间距 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入间距", clearable: "" },
            model: {
              value: _vm.value.config.margin_top,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
              },
              expression: "value.config.margin_top",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "z_index",
          attrs: {
            prop: "z_index",
            rules: [
              {
                required: true,
                pattern: /^(?:[1-9]|[1-9][0-9])$/,
                message: "请输入1-99之间的整数！",
              },
            ],
          },
        },
        [
          _c("div", [_vm._v(" 层级高度值 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入层级高度值", clearable: "" },
            model: {
              value: _vm.value.config.z_index,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
              },
              expression: "value.config.z_index",
            },
          }),
        ],
        1
      ),
      _vm.showPictureLibrary
        ? _c("picture-library", {
            attrs: {
              configData: _vm.value,
              pictureList: _vm.pictureList,
              subhead: _vm.subhead,
              pictureIndex: _vm.pictureIndex,
              depot: _vm.depot,
            },
            on: {
              onClose: function ($event) {
                _vm.showPictureLibrary = false
              },
              onSubmit: _vm.onChangePic,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }